import { API } from "aws-amplify";

const getApiConfig = () => {
    const stage = process.env.REACT_APP_STAGE || 'dev';
    if (stage === 'offline') {
        return { name: 'shows' };
    }
    return { name: 'vivelo' };
};

/* ── Shows ── */

export const getShow = async (showId) => {
    const { name } = getApiConfig();
    return API.get(name, `/shows/${showId}`);
};

/**
 * Get a list of shows with optional filters.
 * Values are NOT url-encoded — caller is responsible for any separators (e.g. commas in status).
 * @param {Object} params - e.g. { sort: 1 } or { filter: 'ALL', sort: -1, status: 'ACTIVE,REPLAY,SOON' }
 */
export const getShows = async (params = {}) => {
    const { name } = getApiConfig();
    const parts = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${k}=${v}`);
    const path = `/shows${parts.length ? `?${parts.join('&')}` : ''}`;
    return API.get(name, path);
};

/**
 * Get child shows (multiple dates) for a parent show.
 * @param {string} parentId
 * @param {Object} params - overrides, e.g. { filter: 'CURRENT', visible: -1 }. Default filter is 'ALL'.
 */
export const getChildShows = async (parentId, params = {}) => {
    const { name } = getApiConfig();
    const merged = { parent: parentId, filter: 'ALL', ...params };
    const parts = Object.entries(merged)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${k}=${v}`);
    return API.get(name, `/shows/?${parts.join('&')}`);
};

/* ── Tickets ── */

/**
 * Get show tickets, optionally filtered by payment type(s).
 * @param {string} showId
 * @param {string} [paymentType] - e.g. 'CREDIT_CARD' or 'CREDIT_CARD|REGISTRATION' (pipe-separated, NOT encoded)
 */
export const getShowTickets = async (showId, paymentType) => {
    const { name } = getApiConfig();
    const qs = paymentType ? `?paymentType=${paymentType}` : '';
    return API.get(name, `/shows/${showId}/tickets${qs}`);
};

/* ── Map ── */

export const getShowMap = async (showId) => {
    const { name } = getApiConfig();
    return API.get(name, `/shows/${showId}/map`);
};
